<template>
  <ul class="days-container no-text-selection">
    <li
      v-for="(day, index) in days"
      :key="index"
      @click="handleInput(day.date)"
      :class="{ 'btn-primary': day.date == date }"
    >
      {{ day.name }}
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    value: {},
  },
  data() {
    return {
      date: this.value,
      days: [],
      selectedDate: "",
    };
  },
  mounted() {
    this.prepareDays();
    this.date = moment().format("YYYY-MM-DD");
  },
  watch: {
    value: function(_val) {
      this.date = _val;
    },
  },
  methods: {
    prepareDays() {
      var days = [];
      days[0] = {
        date: moment()
          .add(-1, "days")
          .format("YYYY-MM-DD"),
        name: "دیروز",
      };
      days[1] = { date: moment().format("YYYY-MM-DD"), name: "امروز" };
      days[2] = {
        date: moment()
          .add(1, "days")
          .format("YYYY-MM-DD"),
        name: "فردا",
      };
      this.days = days;
    },
    handleInput(_val) {
      this.date = _val;
      this.$emit("input", this.date);
    },
  },
};
</script>
<style scoped>
.days-container {
  all: unset;
  list-style: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  gap: 10px;
  flex-wrap: wrap;
}
.days-container li {
  float: right;
  padding: 6px 16px;
  background: #14a8d917;
  border: 1px solid #14A9D9;
}
.days-container li:hover {
  background: #696969;
  cursor: pointer;
}
li.active {
  background: olivedrab;
}
@media (prefers-color-scheme: dark) {
  .days-container li {
    float: right;
    padding: 6px 16px;
    background: #f8fafc;
  }
}
</style>
